import {TOGGLE_SIDE_BAR} from "./actionTypes";

export const toggleSideBar = () => {
  return {
    type: TOGGLE_SIDE_BAR,
  };
};


// WEBPACK FOOTER //
// ./src/actions/sidebar.js